import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Original({ color = 'icon.original', ...props }) {
  return (
    <IconBase viewBox="0 0 15 14" {...props}>
      <Path
        d="M15 7L13.3364 5.14L13.5682 2.68L11.1068 2.13333L9.81818 0L7.5 0.973333L5.18182
         0L3.89318 2.12667L1.43182 2.66667L1.66364 5.13333L0 7L1.66364 8.86L1.43182
          11.3267L3.89318 11.8733L5.18182 14L7.5 13.02L9.81818 13.9933L11.1068 11.8667L13.5682
           11.32L13.3364 8.86L15 7ZM6.19773 10.1467L3.60682 7.60667L4.61591 6.62L6.19773 8.17333L10.1864
            4.26L11.1955 5.24667L6.19773 10.1467Z"
        fill={color}
      />
    </IconBase>
  )
}

Original.propTypes = {
  color: PropTypes.string,
}

export default Original
